import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeleteBookMutation } from '../features/api/apiSlice';
import DeleteIcon from './DeleteIcon';
import EditIcon from './EditIcon';
import StarIcon from './StarIcon';

const BookCard = ({ book }) => {
  const { name, author, thumbnail, price, rating, featured, id } = book;
  const [deleteBook] = useDeleteBookMutation();

  const commaSeperatedNumber = (num) => {
    return Number(num).toLocaleString('en-IN', {
      style: 'currency',
      currency: 'BDT',
      minimumFractionDigits: 0,
    });
  };

  const navigate = useNavigate();
  return (
    <div className="book-card">
      <img
        className="h-[240px] w-[170px] object-cover"
        src={thumbnail}
        alt="book"
      />
      <div className="flex-1 h-full pr-2 pt-2 flex flex-col">
        <div className="flex items-center justify-between">
          {featured && <span className="lws-badge">featured</span>}
          <div className="text-gray-500 space-x-2">
            <button
              className="lws-edit "
              onClick={() => navigate(`/edit/${id}`)}
            >
              <EditIcon />
            </button>
            <button className="lws-deleteBook" onClick={() => deleteBook(id)}>
              <DeleteIcon />
            </button>
          </div>
        </div>

        <div className="space-y-2 mt-4 h-full">
          <h4 className="lws-book-name">{name}</h4>
          <p className="lws-author">{author}</p>
          <div className="lws-stars">
            {Array(rating)
              .fill(0)
              .map((_, i) => (
                <StarIcon key={i} />
              ))}
          </div>
          <p className="lws-price">{commaSeperatedNumber(price)}</p>
        </div>
      </div>
    </div>
  );
};

export default BookCard;
